export const FETCH_FOREX_DEPOSITS_GATEWAYS_START = "FETCH_FOREX_DEPOSITS_GATEWAYS_START";
export const FETCH_FOREX_DEPOSITS_GATEWAYS_SUCCESS = "FETCH_FOREX_DEPOSITS_GATEWAYS_SUCCESS";

export const FETCH_FOREX_WITHDRAWALS_GATEWAYS_START = "FETCH_FOREX_WITHDRAWALS_GATEWAYS_START";
export const FETCH_FOREX_WITHDRAWALS_GATEWAYS_SUCCESS = "FETCH_FOREX_WITHDRAWALS_GATEWAYS_SUCCESS";